module.exports = __webpack_public_path__ + "img/skate-quiz-pair-male.9d84a79e.png";